import { Card } from "@/frontend/components/common";
import type { TournamentFormatConfig } from "@/core/interfaces/tournament";

interface FormatStagesPreviewProps {
  config: TournamentFormatConfig;
}

export function FormatStagesPreview({ config }: FormatStagesPreviewProps) {
  const stages = [...config.stages].sort((a, b) => a.order - b.order);

  if (stages.length === 0) return null;

  return (
    <Card title="Estructura del Formato" className="shadow-sm md:col-span-2">
      <div className="flex flex-wrap gap-4">
        {stages.map((stage, index) => (
          <div key={stage.order} className="flex items-center gap-2">
            <div
              className={`w-10 h-10 rounded-full flex items-center justify-center text-white font-bold ${
                stage.type === "GROUPS"
                  ? "bg-blue-500"
                  : stage.type === "KNOCKOUT"
                    ? "bg-red-500"
                    : "bg-green-500"
              }`}
            >
              {stage.order}
            </div>
            <div>
              <p className="font-medium text-gray-900">{stage.name}</p>
              <p className="text-xs text-gray-500">{stage.type}</p>
            </div>
            {index < stages.length - 1 && (
              <div className="w-8 h-0.5 bg-gray-300 mx-2" />
            )}
          </div>
        ))}
      </div>
    </Card>
  );
}
